import { has, have } from "../../../../../utils/menu-context";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "forRequest" })) {
                if ([undefined, "draft", "reEdit"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forCustoms" })) {
                if (["waitReceiveCustoms", "waitDocCustoms"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forCenter" })) {
                if (["waitApproveCenter"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canDelete: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canDelete" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "forRequest" })) {
                if (["draft"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return ["lastStatus.forRequestRemark.0.remark"].includes(field?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                if (has({ menuContext, key: "forRequest" })) {
                    if ([undefined, "draft", "reEdit"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forOfficeRemark.0.remark"].includes(field?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                if (have({ menuContext, keys: ["forCustoms", "forCenter"] })) {
                    if (["waitReceiveCustoms", "waitApproveCenter", "waitDocCustoms"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refUserBankTemp.refPayBy",
                    "refUserBankTemp.refBank",
                    "refUserBankTemp.branch",
                    "refUserBankTemp.branchCode",
                    "refUserBankTemp.refType",
                    "refUserBankTemp.bankCust",
                    "refUserBankTemp.bankAccount",
                    "refUserBankTemp.bankName"
                ].includes(field?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                if (has({ menuContext, key: "forRequest" })) {
                    if ([undefined, "draft", "reEdit"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refUserBankTemp.companyBranchCode",
                ].includes(field?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                if (has({ menuContext, key: "forRequest" })) {
                    if ([undefined, "draft", "reEdit"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refUserBankTemp.companyBranchName",
                ].includes(field?.key);
            },
            inputPropField: ({ props, initialModel, modelRef }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                if (has({ menuContext, key: "forRequest" })) {
                    if ([undefined, "draft", "reEdit"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                if (modelRef.refUserBankTemp?.companyBranchCode == 0) {
                    enabled = false;
                }
                return { disabled: !enabled };
            }
        }
    ];
};
